export default "__VITE_ASSET__ByV7jfeK__"